msgid ""
msgstr ""
"POT-Creation-Date: 2024-02-16 14:52+0100\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: en\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#. js-lingui-explicit-id
#: src/components/Ad/lib/formatDistance.ts:32
#: src/components/Ad/lib/formatDistance.ts:49
msgid "distance.with-unit"
msgstr "{distance} km"

#. js-lingui-explicit-id
#: src/components/Ad/lib/formatDistance.ts:13
msgid "distance.in-meters"
msgstr "{distance} meters"

#. Mobility unit, km for finn/dba, scandinavian mile for blocket
#. Mobility unit, km for finn/dba, scandinavian mile for blocket
#. js-lingui-explicit-id
#: src/components/Ad/lib/formatDistance.ts:24
#: src/components/Ad/lib/formatDistance.ts:39
msgid "distance.mobility-unit"
msgstr "{distance} mil"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal/filters/RangeFilter.tsx:61
msgid "explore.filter.range.label"
msgstr "{filterName} range"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal/filters/RangeForm.tsx:82
msgid "filters.range.maximum.label"
msgstr "{filterName}, maximum"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal/filters/RangeForm.tsx:68
msgid "filters.range.minimum.label"
msgstr "{filterName}, minimum"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:626
#: src/islands/search/SearchBar.tsx:622
msgid "explore.searchInput.filters.range.both"
msgstr "{min}-{max}"

#. js-lingui-explicit-id
#: src/components/Ad/lib/formatDistance.ts:7
msgid "distance.less-than-100m"
msgstr "100 meters or less"

#. js-lingui-explicit-id
#: src/components/Ad/AdImageWrapper.tsx:22
msgid "search.ad.recommerce.image-alt"
msgstr "Ad image"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal/filters/StandardFilter.tsx:120
msgid "explore.filters.all"
msgstr "All"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:134
#: src/islands/search/FiltersModal.tsx:141
msgid "explore.searchInput.filters.title"
msgstr "All filters"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:853
msgid "explore.searchInput.filters.apply"
msgstr "Apply"

#. js-lingui-explicit-id
#: src/islands/header/Header.tsx:24
#: src/islands/header/Header.tsx:33
#: src/islands/search/StickySearchBar.tsx:76
#: src/islands/search/StickySearchBar.tsx:85
msgid "explore.back.button"
msgstr "Back"

#. js-lingui-explicit-id
#: src/islands/suggestions/Suggestions.tsx:127
msgid "explore.suggestions.title"
msgstr "Based on your search"

#. js-lingui-explicit-id
#: src/islands/results/SearchResult.tsx:135
msgid "explore.results.title"
msgstr "Based on your search"

#. js-lingui-explicit-id
#: src/islands/header/Header.tsx:54
msgid "explore.header.badge"
msgstr "Beta"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:866
msgid "explore.searchInput.filters.clear.single"
msgstr "Clear"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:841
msgid "explore.searchInput.filters.clear"
msgstr "Clear all"

#. js-lingui-explicit-id
#: src/islands/search/SearchBar.tsx:763
#: src/islands/search/SearchBar.tsx:778
msgid "explore.searchInput.clear"
msgstr "Clear text"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:176
#: src/islands/search/FiltersModal.tsx:181
msgid "explore.searchInput.filters.close"
msgstr "Close filters"

#. js-lingui-explicit-id
#: src/islands/results/ErrorState.tsx:52
msgid "explore.results.errorstate.network.heading"
msgstr "Connection Error"

#. js-lingui-explicit-id
#: src/islands/suggestions/Suggestions.tsx:74
msgid "explore.suggestions.title.discover.more"
msgstr "Discover more"

#. js-lingui-explicit-id
#: src/islands/header/Header.tsx:48
msgid "explore.header.title"
msgstr "Explore"

#. js-lingui-explicit-id
#: src/server/server.ts:170
msgid "page.title"
msgstr "Explore - Find your next recommerce deal with AI"

#. js-lingui-explicit-id
#: src/islands/results/SortingInfo.tsx:58
msgid "explore.sorting.info.body-try-it-two"
msgstr "Explore analyses all the information in a listing, including images, when searching for results. The traditional search on recommerce only scans the text on listings."

#. js-lingui-explicit-id
#: src/islands/results/SortingInfo.tsx:55
msgid "explore.sorting.info.title-two"
msgstr "Explore analyses text and images"

#. js-lingui-explicit-id
#: src/islands/results/ErrorState.tsx:26
msgid "explore.results.errorstate.server.message"
msgstr "Explore isn’t working right now, but we’re on it. Please try again later!"

#. js-lingui-explicit-id
#: src/islands/results/SortingInfo.tsx:36
msgid "explore.sorting.info.body-one"
msgstr "Explore uses AI to understand what you're looking for. Unlike traditional search on recommerce, which only shows results including your exact search term, Explore looks beyond keywords to find listings that match your intent."

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal/filters/RangeFilter.tsx:57
#: src/islands/search/FiltersModal/filters/StandardFilter.tsx:60
#: src/islands/search/FiltersModal/filters/StandardFilter.tsx:86
msgid "explore.filter.fallback"
msgstr "Filter"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:137
msgid "explore.searchInput.filters.back"
msgstr "Filter"

#. js-lingui-explicit-id
#: src/islands/search/SearchBar.tsx:824
msgid "explore.searchInput.filters"
msgstr "Filters"

#. js-lingui-explicit-id
#: src/islands/results/SortingInfo.tsx:22
msgid "explore.sorting.info.trigger"
msgstr "Find out how it works"

#. js-lingui-explicit-id
#: src/islands/header/Header.tsx:61
msgid "explore.prompt.subtitle"
msgstr "Find your next recommerce deal with AI"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:638
#: src/islands/search/SearchBar.tsx:628
#: src/islands/search/SearchBar.tsx:687
msgid "explore.searchInput.filters.range.min"
msgstr "From {value}"

#. js-lingui-explicit-id
#: src/islands/results/FeedbackPrompt.tsx:70
msgid "explore.results.feedback.followup.button"
msgstr "Give feedback"

#. js-lingui-explicit-id
#: src/islands/results/ErrorState.tsx:79
msgid "explore.results.errorstate.goback.label"
msgstr "Go back to search on recommerce"

#. js-lingui-explicit-id
#: src/islands/results/SearchResult.tsx:143
msgid "explore.results.count.hits"
msgstr "hits"

#. js-lingui-explicit-id
#: src/islands/results/SortingInfo.tsx:29
msgid "explore.sorting.title"
msgstr "How Explore works"

#. js-lingui-explicit-id
#: src/islands/suggestions/Suggestions.tsx:98
#: src/islands/suggestions/Suggestions.tsx:165
msgid "explore.suggestions.buttons.loading"
msgstr "Loading suggestion"

#. js-lingui-explicit-id
#: src/islands/suggestions/Suggestions.tsx:56
msgid "explore.suggestions.placeholder"
msgstr "Loading..."

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal/filters/RangeFilter.tsx:111
msgid "explore.searchInput.filters.range.max.label"
msgstr "Maximum value"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal/filters/RangeFilter.tsx:107
msgid "explore.searchInput.filters.range.min.label"
msgstr "Minimum value"

#. js-lingui-explicit-id
#: src/islands/results/FeedbackPrompt.tsx:102
msgid "explore.results.feedback.negative.label"
msgstr "Negative feedback"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:707
msgid "explore.searchInput.filters.empty"
msgstr "No filters available"

#. js-lingui-explicit-id
#: src/islands/results/ZeroResults.tsx:30
msgid "explore.results.zero-results.alt-text"
msgstr "No results found"

#. js-lingui-explicit-id
#: src/islands/results/ZeroResults.tsx:36
msgid "explore.results.zero-results.heading"
msgstr "No results found"

#. js-lingui-explicit-id
#: src/islands/results/ErrorState.tsx:37
msgid "explore.results.errorstate.client.heading"
msgstr "Oh no!"

#. js-lingui-explicit-id
#: src/islands/results/FeedbackPrompt.tsx:92
msgid "explore.results.feedback.positive.label"
msgstr "Positive feedback"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal/filters/RangeFilter.tsx:60
msgid "explore.filter.price.label"
msgstr "Price range"

#. js-lingui-explicit-id
#: src/server/server.ts:171
msgid "page.description"
msgstr "Recommerce page to enable semantic search for exploration"

#. js-lingui-explicit-id
#: src/islands/search/SearchBar.tsx:742
#: src/islands/search/SearchBar.tsx:791
msgid "explore.searchInput.ariaLabel"
msgstr "Search"

#. js-lingui-explicit-id
#: src/islands/results/SortingInfo.tsx:69
msgid "explore.sorting.info.body-try-it-two-rest"
msgstr "Search for “Outfit for an office summer party”, and Explore will suggest clothing suited for the occasion."

#. js-lingui-explicit-id
#: src/islands/results/SortingInfo.tsx:33
msgid "explore.sorting.info.title-one"
msgstr "Search results based on intent"

#. js-lingui-explicit-id
#: src/islands/search/SearchBar.tsx:855
msgid "explore.searchInput.calloutText"
msgstr "Search with a sentence"

#. js-lingui-explicit-id
#: src/components/Ad/AdLocation.tsx:20
msgid "search.ad.bap.sold"
msgstr "Sold"

#. js-lingui-explicit-id
#: src/islands/results/ErrorState.tsx:41
msgid "explore.results.errorstate.client.message"
msgstr "Something went wrong, and we couldn’t load any items. Please try again!"

#. js-lingui-explicit-id
#: src/islands/results/ErrorState.tsx:22
msgid "explore.results.errorstate.server.heading"
msgstr "Sorry!"

#. js-lingui-explicit-id
#: src/islands/results/FeedbackPrompt.tsx:26
msgid "explore.results.feedback.followup.negative"
msgstr "Thanks! Do you want to tell us more about what you didn't like?"

#. js-lingui-explicit-id
#: src/islands/results/FeedbackPrompt.tsx:21
msgid "explore.results.feedback.followup.positive"
msgstr "Thanks! Do you want to tell us more about what you liked?"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal/filters/RangeForm.tsx:98
msgid "explore.filter.range.invalid"
msgstr "The maximum value can't be smaller than the minimum value."

#. js-lingui-explicit-id
#: src/islands/search/SearchBar.tsx:795
msgid "explore.searchInput.helpText"
msgstr "Tip! Use descriptive sentences"

#. js-lingui-explicit-id
#: src/islands/results/ErrorState.tsx:136
#: src/islands/results/ErrorState.tsx:142
msgid "explore.results.errorstate.retry.label"
msgstr "Try again"

#. js-lingui-explicit-id
#: src/islands/results/SortingInfo.tsx:45
#: src/islands/results/SortingInfo.tsx:67
msgid "explore.sorting.info.try-it"
msgstr "Try it!"

#. js-lingui-explicit-id
#: src/islands/suggestions/Suggestions.tsx:131
msgid "explore.suggestions.title.discover"
msgstr "Try to look for"

#. js-lingui-explicit-id
#: src/islands/results/ZeroResults.tsx:43
msgid "explore.results.zero-results.message"
msgstr "Try to rephrase your search or adjust your filters to find what you're looking for."

#. js-lingui-explicit-id
#: src/components/Ad/AdImageOptions.tsx:15
msgid "search.ad.fallback-image-alt"
msgstr "Two mountains and a cloud"

#. js-lingui-explicit-id
#: src/islands/results/SortingInfo.tsx:47
msgid "explore.sorting.info.body-try-it-one-rest"
msgstr "Type “Vintage kitchen items”, and Explore will suggest relevant listings like vintage tableware, lamps, and decorations."

#. js-lingui-explicit-id
#: src/islands/suggestions/Suggestions.tsx:82
#: src/islands/suggestions/Suggestions.tsx:149
msgid "explore.suggestions.title.error"
msgstr "Unable to load suggestions. Please try again."

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:647
#: src/islands/search/SearchBar.tsx:634
#: src/islands/search/SearchBar.tsx:689
msgid "explore.searchInput.filters.range.max"
msgstr "Up to {value}"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:878
msgid "explore.searchInput.filters.use"
msgstr "Use"

#. js-lingui-explicit-id
#: src/islands/results/ErrorState.tsx:110
#: src/islands/results/ErrorState.tsx:116
msgid "explore.results.errorstate.help.center.label"
msgstr "Visit our help center"

#. js-lingui-explicit-id
#: src/islands/results/ErrorState.tsx:56
msgid "explore.results.errorstate.network.message"
msgstr "We couldn't reach our servers. Please check your internet connection and try again."

#. js-lingui-explicit-id
#: src/islands/search/SearchBar.tsx:787
msgid "explore.searchInput.placeholder"
msgstr "What are you looking for?"

#. js-lingui-explicit-id
#: src/islands/results/FeedbackPrompt.tsx:83
msgid "explore.results.feedback.prompt"
msgstr "What do you think about Explore?"
